import {
  chainReducers,
  createDraftReducer,
  createFetchListReducer,
} from 'common/reducers/utils';

import {
  CLEAR_PAYMENT_CONNECT,
  SEND_PAYMENT_CONNECT,
  RECEIVE_PAYMENT_CONNECT_ERROR,
  RECEIVE_PAYMENT_CONNECT_SUCCESS,
} from 'common/actions/agencySettings';
import AgencySettings from 'common/types/AgencySettings';


const defaultReducer = chainReducers(
  createDraftReducer({
    name: 'agency setting',
    DataType: AgencySettings,
  }),
  createFetchListReducer({
    name: 'agency setting',
    keys: ['agency'],
  }),
);

export default function agencySetting(state = {
  draft: {
    past: [],
    present: {
      model: null,
      errors: [],
    },
    future: [],
  },
  items: {},
  isFetching: false,
  isSaving: false,
  payment: {
    isSaving: false,
    hasError: false,
  },
  agency: null,
}, action) {
  switch (action.type) {
    case CLEAR_PAYMENT_CONNECT:
      return Object.assign({}, state, {
        payment: {
          isSaving: false,
          hasError: false,
        },
      });
    case SEND_PAYMENT_CONNECT:
      return Object.assign({}, state, {
        payment: {
          isSaving: true,
          hasError: false,
        },
      });
    case RECEIVE_PAYMENT_CONNECT_ERROR:
      return Object.assign({}, state, {
        payment: {
          isSaving: false,
          hasError: true,
        },
      });
    case RECEIVE_PAYMENT_CONNECT_SUCCESS:
      return Object.assign({}, state, {
        payment: {
          isSaving: false,
          hasError: false,
        },
      });
    default:
      return defaultReducer(state, action);
  }
}



// WEBPACK FOOTER //
// ./src/common/reducers/agencySetting.js